module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/thurston_promo_custom.22183b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/thurston_promo_custom.jpg
// module id = mSyt
// module chunks = 1